import type {
  CharacterFormArrayInput,
  CreateCharactersSuccessResponse,
  CharacterFormState,
} from 'schemas';
import {
  CreateCharactersResponseSchema,
  CreateCharactersRequestSchema,
} from 'schemas';
import { apiRequest } from '@/api/helpers/apiRequest';
import { fileToDataUrl } from '@/helpers/file-manipulation/fileToDataUrl';
import { handleApiError } from '@/api/helpers/handleApiError';

export const createCharacters = async (
  charactersData: CharacterFormArrayInput,
  styleTemplateId?: string
): Promise<CreateCharactersSuccessResponse['data']> => {
  try {
    // Convert images to data URLs and prepare request data
    const charactersWithDataUrls = await Promise.all(
      charactersData.characters.map(async (character: CharacterFormState) => {
        const dataUrl = character.reference_image
          ? await fileToDataUrl(character.reference_image as File)
          : '';

        return {
          name: character.name,
          age: character.age ?? 0, // Default to 0 if undefined TODO decide how to robustly handle optional fields
          gender: character.gender ?? 'gender_neutral', // Default to gender_neutral if undefined TODO decide how to robustly handle optional fields
          referenceImageData: dataUrl,
        };
      })
    );

    const requestData = {
      characters: charactersWithDataUrls,
      ...(styleTemplateId && { styleTemplateId }),
    };

    const validatedRequest = CreateCharactersRequestSchema.parse(requestData);

    return await apiRequest(
      'POST',
      '/api/characters',
      validatedRequest,
      CreateCharactersResponseSchema
    );
  } catch (error) {
    handleApiError(error);
  }
};
